import { Button, Card, Elevation } from "@blueprintjs/core";
import fetch from "node-fetch";
import React from 'react';
import Helmet from 'react-helmet';
import { Link, withRouter } from 'react-router-dom';
import Sugar from "sugar";
import dateUtils from '../../../utils/date';
import waitForGlobal from '../../../utils/scriptLoad';
import SimpleModal from '../../components/simple-modal';

class RentPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: waitForGlobal('bolt'),
      showModal: false,
      modalContent: null
    }
  }

  componentWillMount() {
    window.scrollTo(0, 0);
  }

  paymentSuccess = (data) => {
    const modalContent = (
      <div>
        <div className="has-text-centered is-size-6">
          <p className="has-text-success has-text-weight-semibold is-size-5">Payment Successful!</p>
          <p>You have successfully made payment for online rent agreement.</p>
          <p>Continue to fill the details for Tenant and Owner.</p>
          <code>
            Transaction Id: {data.paymentDetail.pgTxnId}
          </code>
          <code>
            Total Amount: {data.paymentDetail.amount}
          </code>
        </div>
        <Button
          fill large
          intent="primary"
          onClick={(() => this.props.paymentSuccess())}
          className="w-320"
          style={{ marginTop: "2rem" }}
          text="Continue"
        />
      </div>
    )

    this.setState({ modalContent, showModal: true });
  }

  paymentFailed = (BOLT) => {
    const modalContent = (
      <div>
        <div className="has-text-centered is-size-6">
          <p className="has-text-danger has-text-weight-semibold is-size-5">Something went wrong!</p>
          <p>The payment for your rent agreement was not successfull.</p>
          <p>Kindly try again or Contact our representative for more details.</p>
          {/* <code>
            {JSON.stringify(BOLT)}
          </code> */}
        </div>
        <Button
          fill large
          intent="danger"
          onClick={(() => window.location.reload())}
          className="w-320"
          style={{ marginTop: "2rem" }}
          text="Continue"
        />
      </div>
    )

    this.setState({ modalContent, showModal: true });
  }

  launchBolt = () => {
    const formData = this.props.data.pgFormData;
    const surl = '/v2/pg-payment-response/payu';
    const paymentSuccess = this.paymentSuccess;
    const paymentFailed = this.paymentFailed;

    const requestData = {
      key: formData.key,
      txnid: formData.txnId,
      hash: formData.secureHash,
      amount: formData.amount.toFixed(1),
      firstname: formData.firstName,
      email: formData.email,
      phone: formData.phone,
      productinfo: formData.productInfo,
      // surl: window.location.hostname + '/payment/success',
      // furl: window.location.hostname + '/payment/failed',
      surl: surl,
      furl: formData.failureUrl,
      // mode: 'dropout'// non-mandatory for Customized Response Handling
    };

    const handler = {
      responseHandler: function (BOLT) {
        // your payment response Code goes here, BOLT is the response object
        const response = BOLT.response;
        if (response.txnStatus === "SUCCESS") {
          const apiResponse = {
            status: "success",
            txnId: response.txnid,
            amount: parseFloat(response.amount).toFixed(1),
            productInfo: response.productinfo,
            mobile: response.phone,
            email: response.email,
            firstName: response.firstname,
            secureHash: response.hash,
            pgPaymentId: response.payuMoneyId,
            pgPaymentMode: response.mode
          }
          fetch(surl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify(apiResponse)
          })
            .then(res => res.json())
            .then((result) => {
              if (result.message !== 'Ok') {
                console.log(result.message);
              } else if (result.data.paymentDetail) {
                paymentSuccess(result.data);
              }
            })
        } else if (response.txnStatus === "FAILED") {
          fetch(surl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify(response)
          })
            .then(res => res.json())
            .then((result) => {
              if (result.message !== 'Ok') {
                console.log(result.message);
              }
            });
          paymentFailed(response);
        }
      },
      catchException: function (BOLT) {
        // console.log(BOLT);
      }
    }

    window.bolt.launch(requestData, handler);
  }

  render() {
    console.log(this.props.data)
    // const pgFormData = {
    //   "payUrl": "https://sandboxsecure.payu.in/_payment",
    //   "key": "GBk1whkV",
    //   "txnId": "OHAFXZNIVHL4",
    //   "amount": 2100.0,
    //   "productInfo": "Lease Agreement",
    //   "phone": "1234567890",
    //   "email": "test@test.com",
    //   "firstName": "Test",
    //   "successUrl": "http://localhost:33333/v1/pg-payment-response/payu",
    //   "failureUrl": "http://localhost:33333/v1/pg-payment-response/payu",
    //   "secureHash": "a3f1452f0b385fc84704aaf07ca7af7aa6fdd6ce371456969bf0ab140fda622dde0ca779f7fde94006bbef7fb4f1e29ed721d41d5f423da88da25f0fd8f410b6",
    //   "serviceProvider": "payu_paisa"
    // }
    const pgFormData = this.props.data.pgFormData;
    return (
      <div>
        <Helmet>
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
          <script id="bolt" src="https://sboxcheckout-static.citruspay.com/bolt/run/bolt.min.js" />
        </Helmet>
        <SimpleModal content={this.state.modalContent} show={this.state.showModal} />
        <Card className="card is-size-6" elevation={Elevation.ONE}>
          <div className="columns is-mobile">
            <div className="column is-narrow">
              Period:
          </div>
            <div className="column has-text-right has-text-weight-semibold">
              {dateUtils.strToDate(this.props.data.startDate).toLocaleDateString()} - {dateUtils.strToDate(this.props.data.endDate).toLocaleDateString()}
            </div>
          </div>
          <div className="columns is-mobile">
            <div className="column is-narrow">
              Refundable Deposit:
          </div>
            <div className="column has-text-right has-text-weight-semibold">
              {Sugar.Number.format(this.props.data.depositAmount)}
            </div>
          </div>
          <div className="columns is-mobile">
            <div className="column is-narrow col-thin">
              Non-refundable Deposit:
          </div>
            <div className="column has-text-right has-text-weight-semibold col-thin">
              {Sugar.Number.format(this.props.data.nonRefundableDepositAmount)}
            </div>
          </div>
          <div className="columns is-mobile">
            <div className="column is-narrow">
              Rent:
          </div>
            <div className="column has-text-right has-text-weight-semibold">
              {Sugar.Number.format(this.props.data.monthlyRentAmount)}
            </div>
          </div>
          {this.props.data.isRentIncremental ?
            <div className="columns is-mobile">
              <div className="column is-narrow col-thin">
                Increment after {this.props.data.rentIncrementInMonths} Month:
            </div>
              <div className="column col-thin has-text-right has-text-weight-semibold">
                {this.props.data.rentIncrementMode === "Percent" ?
                  this.props.data.rentIncrementValue * this.props.data.monthlyRentAmount / 100 :
                  this.props.data.rentIncrementValue
                }
              </div>
            </div> : null
          }
          <div className="columns is-mobile">
            <div className="column is-narrow">
              Stamp Duty:
          </div>
            <div className="column has-text-right has-text-weight-semibold">
              {Sugar.Number.format(this.props.data.paymentDetail.stampDutyAmount)}
            </div>
          </div>
          <div className="columns is-mobile">
            <div className="column is-narrow col-thin">
              Registration Charges:
          </div>
            <div className="column col-thin has-text-right has-text-weight-semibold">
              {Sugar.Number.format(this.props.data.paymentDetail.registrationAmount)}
            </div>
          </div>
          <div className="columns is-mobile">
            <div className="column is-narrow col-thin">
              Doorstep Service Charges:
          </div>
            <div className="column col-thin has-text-right has-text-weight-semibold">
              {Sugar.Number.format(this.props.data.paymentDetail.doorstepServiceAmount)}
            </div>
          </div>
          <div className="columns is-mobile is-size-7">
            <div className="column is-narrow col-thin">
              Convenience Charge:
          </div>
            <div className="column col-thin has-text-right has-text-weight-semibold">
              {Sugar.Number.format(this.props.data.paymentDetail.convenienceAmount)}
            </div>
          </div>
          <div className="columns is-mobile is-size-7">
            <div className="column is-narrow col-thin">
              GST:
          </div>
            <div className="column col-thin has-text-right has-text-weight-semibold">
              {Sugar.Number.format(this.props.data.paymentDetail.gstAmount)}
            </div>
          </div>
          <div className="columns is-mobile">
            <div className="column is-narrow has-text-black">
              Total:
          </div>
            <div className="column has-text-right has-text-weight-semibold has-text-black">
              {Sugar.Number.format(this.props.data.paymentDetail.amount)}
            </div>
          </div>
        </Card>
        <div className="columns is-mobile">
          <div className="column is-6">
            <div className="btn-block">
              <Link to={`/rentagreement/${this.props.data.uid}`} className="bp3-button bp3-fill bp3-large">
                Back
            </Link>
            </div>
          </div>
          <div className="column is-6">
            <div className="btn-block">
              {/* <form action={pgFormData.payUrl} method="POST">
                  <input name="key" type="hidden" value={pgFormData.key} />
                  <input name="txnid" type="hidden" value={pgFormData.txnId} />
                  <input name="amount" type="hidden" value={pgFormData.amount} />
                  <input name="productinfo" type="hidden" value={pgFormData.productInfo} />
                  <input name="phone" type="hidden" value={pgFormData.phone} />
                  <input name="email" type="hidden" value={pgFormData.email} />
                  <input name="firstname" type="hidden" value={pgFormData.firstName} />
                  <input name="surl" type="hidden" value="http://139.59.32.189:33333/v1/pg-payment-response/payu" />
                  <input name="furl" type="hidden" value="http://139.59.32.189:33333/v1/pg-payment-response/payu" />
                  <input name="hash" type="hidden" value={pgFormData.secureHash} />
                  <input name="service_provider" type="hidden" value={pgFormData.serviceProvider} />
                  </form> */}
              {pgFormData ?
                <Button
                  onClick={this.launchBolt}
                  disabled={!this.state.loaded}
                  // type="submit"
                  intent="success"
                  fill large
                  text="Pay"
                />
                : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(RentPreview);


// WEBPACK FOOTER //
// ./src/app/components/rent-agreement-details/rent-preview.js